<template>
  <div>
    <checkbox-config
      v-if="config.type === 'checkbox'"
      :data.sync="data"
      :config="config"
      @update:data="onDataUpdated"
    />
    <select-config
      v-else-if="config.type === 'select'"
      :data.sync="data"
      :config="config"
      @update:data="onDataUpdated"
    />
  </div>
</template>

<script>
import CheckboxConfig from "./CheckboxConfig.vue";
import SelectConfig from "./SelectConfig.vue";

export default {
  components: {
    CheckboxConfig,
    SelectConfig,
  },
  props: {
    fieldTypeCfg: Object,
    config: Object,
  },
  data() {
    return {
      data: {},
    };
  },
  created() {
    this.data = JSON.parse(JSON.stringify(this.fieldTypeCfg || {}));
  },
  methods: {
    onDataUpdated(newData) {
      this.data = newData;
      this.$emit("update:data", this.data);
    },
  },
  watch: {
    data: {
      handler(val) {
        this.$emit("update:data", val);
      },
      deep: true,
    },
  },
};
</script>

<style></style>
